<div
    style="display: flex;justify-content: space-between;height: 7%;align-items: center; color:#545454eb;padding: 0 0.5rem;">
    <span multilang style="font-size: 1.3rem;font-weight: 600;">{{title}}</span>
    <span multilang>
        <button mat-dialog-close mat-icon-button>
            <mat-icon>close</mat-icon>
        </button>
    </span>
</div>
<mat-divider></mat-divider>
<div style="display: flex;flex-direction: column;overflow:auto;height: 91% !important;padding: 0 0.5rem;">
    <div *ngIf="datas">
        <div
            style="display: flex;flex-direction: column;padding: .5rem;overflow: hiden;border: 1px solid #e4dfdf;margin-top: .5rem;">
            <div
                style="display: flex;flex-direction: column;justify-content: space-between;flex-wrap: wrap;align-items: center;color:#545454eb;">
                <!--CarParkName-->
                <span multilang style="font-style: italic;font-weight: 800;font-size: 1.3rem;">
                    {{datas.CarParkName}}
                </span>
                <div style="display: flex;flex-direction: row;justify-content: center;flex-wrap: wrap;">
                    <img class="lazyload" *ngFor="let img of data.infos.imageList;" [ngIf]="img.url?.length > 0"
                        data-src="{{img.url}}" style="width:calc(50% - 2rem);margin: 0.5rem;">
                </div>
                <h1 multilang>Wichtige Informationen</h1>
                <!--Address-->
                <div class="infoline">
                    <span multilang style="width: 40%;">Adresse</span>
                    <span multilang style="width: 60%;">
                        {{datas.Address}}
                    </span>
                </div>
                <!--Transfer-->
                <div class="infoline">
                    <span multilang style="width: 40%;">Transferinformationen</span>
                    <span multilang style="width: 60%;">
                        {{datas.Transfer}}
                    </span>
                </div>
                <!--ShuttleTimes-->
                <div class="infoline">
                    <span multilang style="width: 40%;">Zeiten</span>
                    <span multilang style="width: 60%;">
                        {{datas.ShuttleTimes}}
                    </span>
                </div>
                <!--ShuttleFrequency-->
                <div class="infoline">
                    <span multilang style="width: 40%;">Häufigkeit</span>
                    <span multilang style="width: 60%;">
                        {{datas.ShuttleFrequency}}
                    </span>
                </div>
                <!--Special-->
                <div class="infoline">
                    <span multilang style="width: 40%;">Individueller Transfer</span>
                    <span multilang style="width: 60%;">
                        {{datas.Special}}
                    </span>
                </div>
                <!--ArrivalProcedure-->
                <div class="infoline">
                    <span multilang style="width: 40%;">Bei der Anreise</span>
                    <span multilang style="width: 60%;">
                        {{datas.ArrivalProcedure}}
                    </span>
                </div>
                <!--DepartureProcedure-->
                <div class="infoline">
                    <span multilang style="width: 40%;">Bei der Abreise</span>
                    <span multilang style="width: 60%;">
                        {{datas.DepartureProcedure}}
                    </span>
                </div>
                <!--Weitere informationen-->
                <h1 multilang>Weitere informationen</h1>
                <!--CarSizeInfo-->
                <div class="infoline">
                    <span multilang style="width: 40%;">Fahrzeuggröße</span>
                    <span multilang style="width: 60%;">
                        {{datas.CarSizeInfo}}
                    </span>
                </div>
                <!--Accessibility-->
                <div class="infoline">
                    <span multilang style="width: 40%;">Informationen für Behinderte</span>
                    <span multilang style="width: 60%;">
                        {{datas.Accessibility}}
                    </span>
                </div>
                <!--Accessibility-->
                <!--span>Zusatzinformationen</span>
                <span multilang style="font-weight: 500;">
                    {{datas.Accessibility}}
                </span-->
                <!--SecurityInfo-->
                <div class="infoline">
                    <span multilang style="width: 40%;">Sicherheitsinformationen</span>
                    <span multilang style="width: 60%;">
                        {{datas.SecurityInfo}}
                    </span>
                </div>
                <!--Insurance-->
                <div class="infoline">
                    <span multilang style="width: 40%;">Versicherungsinformationen</span>
                    <span multilang style="width: 60%;">
                        {{datas.Insurance}}
                    </span>
                </div>
                <!--ChildSeat-->
                <div class="infoline">
                    <span multilang style="width: 40%;">Kindersitze</span>
                    <span multilang style="width: 60%;">
                        {{datas.ChildSeat}}
                    </span>
                </div>
                <!--DirectionsShort-->
                <h1 multilang>Anfahrt</h1>
                <span multilang style="font-weight: 500;">
                    {{datas.DirectionsShort}}
                </span>
                <!--MinimumarkingDays-->
                <h1 multilang>Parkplatz-Nutzungsdauer</h1>
                <div class="infoline">
                    <span multilang style="width: 40%;">min. Parkdauer</span>
                    <span multilang style="width: 60%;">
                        {{datas.MinimumParkingDays}}
                    </span>
                </div>
                <div class="infoline">
                    <span multilang style="width: 40%;">max. Parkdauer</span>
                    <span multilang style="width: 60%;">
                        {{datas.MaximumParkingDays}}
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>